/**
 * Categorías de la tienda (slug en URL y en BD).
 * Incluye la vista especial "sale" (ofertas), que no es una categoría de asignación de producto.
 * "ropa" agrupa hombre+mujer en la tienda; en admin solo se asigna ropa-hombre / ropa-mujer.
 */
export const STORE_CATEGORIES = [
  {
    slug: 'ropa',
    label: 'Ropa',
    isStoreFilterOnly: true,
    description: 'Vista combinada: ropa hombre y mujer.'
  },
  { slug: 'ropa-hombre', label: 'Ropa hombre' },
  { slug: 'ropa-mujer', label: 'Ropa mujer' },
  { slug: 'combos', label: 'Combos' },
  { slug: 'productos-naturales', label: 'Productos naturales' },
  { slug: 'instrumentos-musicales', label: 'Instrumentos musicales' },
  { slug: 'joyeria-artesanias', label: 'Joyería y artesanías' },
  { slug: 'bienestar', label: 'Bienestar' },
  { slug: 'tecnologia', label: 'Tecnología' },
  { slug: 'jardineria', label: 'Jardinería' },
  {
    slug: 'sale',
    label: 'Ofertas',
    isOfferView: true,
    description:
      'Vista especial: muestra productos con descuento de todas las categorías. No se asigna como categoría al crear un producto.'
  }
];

/** Slugs para filtros de la tienda (incluye ofertas). */
export const STORE_CATEGORY_SLUGS = STORE_CATEGORIES.map((c) => c.slug);

/** Categorías asignables al crear/editar producto (excluye ofertas y filtros solo-tienda como "ropa"). */
export const PRODUCT_CATEGORIES = STORE_CATEGORIES.filter((c) => !c.isOfferView && !c.isStoreFilterOnly);

export const DEFAULT_STORE_CATEGORY = 'ropa-hombre';

export const MAX_EXTRA_PRODUCT_TAXES = 5;

/** Medidas por tipo de empaque (cm) — alineadas con EnviaService (cotización backend).
 * Admin MVP: 3 opciones (kraft chica/mediana). `caja_grande` no se ofrece en el select. */
export const PACKAGE_TYPE_DIMENSIONS_CM = {
  sobre: { l: 25, w: 18, h: 3, label: 'Sobre / bolsa kraft chica (25 × 18 × 3 cm)' },
  caja_pequena: { l: 25, w: 20, h: 12, label: 'Bolsa kraft / caja pequeña (25 × 20 × 12 cm)' },
  caja_mediana: { l: 35, w: 25, h: 18, label: 'Bolsa kraft / caja mediana (35 × 25 × 18 cm)' }
};
